import { useContext } from 'react';
import { isWwsWeddingWebsiteV2 } from '../../../../types/graphql';
import InitialsDateLockup from '../../InitialsDateLockup';
import ThemeAttribution from '../../ThemeAttribution';
import { WWContext, WWContextValue } from '../../../WWContext';
import { memo } from 'react';
import styled from '@emotion/styled';
import { getCoupleNames } from '../../../../lib/getCoupleNames';

const FooterWrapper = styled('div')`
  padding-top: ${({ isSinglePageView }: FooterProps) =>
    isSinglePageView ? '300px' : '50px'};
`;

interface FooterProps {
  isSinglePageView?: boolean;
}

const Footer = ({ isSinglePageView = false }: FooterProps) => {
  const { data } = useContext<WWContextValue>(WWContext);
  
  if (!isWwsWeddingWebsiteV2(data?.weddingWebsiteResult)) {
    return null;
  }
  
  const [primaryName, secondaryName] = getCoupleNames({ weddingWebsiteResult: data?.weddingWebsiteResult }) ?? [];
  
  return (
    <FooterWrapper isSinglePageView={isSinglePageView}>
      <InitialsDateLockup
        firstName={primaryName}
        fianceFirstName={secondaryName}
      />
      <ThemeAttribution />
    </FooterWrapper>
  );
};

export default memo(Footer);
